import type { InspectionTemplate, TemplateSection } from 'inspection-types';

import { isLocal } from './origin';

export type SectionCounts = {
  visible: number;
  total: number;
  local: number;
};

export type TemplateCounts = {
  sections: number;
  questions: number;
};

export function countSectionItems(section: TemplateSection): SectionCounts {
  const visible = section.items.filter(item => !item.removed).length;
  const local = section.items.filter(isLocal).length;

  return { visible, total: section.items.length, local };
}

export function countTemplate(template: InspectionTemplate): TemplateCounts {
  const visibleSections = template.sections.filter(section => !section.removed);
  const questions = visibleSections.reduce(
    (sum, section) => sum + countSectionItems(section).visible,
    0
  );

  return { sections: visibleSections.length, questions };
}
